/**
 * Component Registry for Stonebriar Woods Apartment Homes
 * 
 * Inherits from @vibesites-price-brothers/theme-preferred and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-price-brothers/theme-preferred/registry';
import { Hero } from './components/Hero';
import { SisterProperties } from './components/SisterProperties';
import { SisterPropertiesHero } from './components/SisterPropertiesHero';

/**
 * Property-specific component overrides.
 * Uncomment and customize components as needed.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  Hero,
  SisterProperties,
  SisterPropertiesHero,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
